import useMediaQuery from './useMediaQuery'

const useBreakpoint = (breakpoint) => useMediaQuery(`(min-width: ${breakpoint}px)`)

export default useBreakpoint
